import type { Cliente } from '../db/tipos'

export type Classificacao = NonNullable<Cliente['potencial']>

// Ordem do melhor para o menor. A LETRA e o que vai para o banco; o nome mora
// aqui. Motivo: letra tem ordem natural, entao "meus melhores clientes" ordena
// sozinho por potencial. Guardando as palavras, o banco ordenaria bronze,
// niquel, ouro, prata -- alfabetico e inutil.
export const CLASSIFICACOES: ReadonlyArray<Classificacao> = ['A', 'B', 'C', 'D']

export const ROTULO_CLASSIFICACAO: Record<Classificacao, string> = {
  A: 'Ouro',
  B: 'Prata',
  C: 'Bronze',
  D: 'Níquel',
}

export const EMOJI_CLASSIFICACAO: Record<Classificacao, string> = {
  A: '🥇',
  B: '🥈',
  C: '🥉',
  D: '⚙️',
}

// O texto que aparece na lista de clientes. Uma funcao so, e nao a montagem
// repetida em cada tela: tres copias de um rotulo divergem com o tempo -- foi
// por isso que o aviso de cliente inativo virou um componente unico.
export function rotuloClassificacao(potencial: Cliente['potencial']): string | null {
  if (!potencial) return null
  const nome = ROTULO_CLASSIFICACAO[potencial]
  const emoji = EMOJI_CLASSIFICACAO[potencial]
  // Valor fora da lista: silencio. Nunca "undefined" impresso na tela de quem
  // esta na rua.
  if (!nome || !emoji) return null
  return `${emoji} ${nome}`
}
